module.exports = __webpack_public_path__ + "img/eu.ba0f7f74.svg";